export default "__VITE_ASSET__DVyfYogz__"